import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "kovi_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const AD_TYPES = [
  ["image-banner", "Image Banner"],
  ["html-banner", "HTML Banner"],
  ["adsense", "Google AdSense"],
  ["ad-manager", "Google Ad Manager"],
  ["affiliate-banner", "Affiliate Banner"],
  ["affiliate-button", "Affiliate Button"],
  ["affiliate-card", "Affiliate Product Card"],
  ["native", "Native Ad"],
  ["video", "Video Ad"],
  ["popup", "Popup Ad"],
  ["announcement-bar", "Announcement Bar"],
  ["sticky-footer", "Sticky Footer Banner"],
  ["sticky-sidebar", "Sticky Sidebar Banner"],
  ["floating", "Floating Banner"],
  ["inline-content", "Inline Content Banner"],
];

export const PLACEMENTS = [
  ["homepage-hero", "Homepage Hero"],
  ["homepage-below-search", "Homepage Below Search"],
  ["homepage-categories", "Homepage Categories"],
  ["homepage-middle", "Homepage Middle"],
  ["homepage-bottom", "Homepage Bottom"],
  ["tool-page-top", "Tool Page Top"],
  ["tool-page-middle", "Tool Page Middle"],
  ["tool-page-bottom", "Tool Page Bottom"],
  ["sidebar", "Sidebar"],
  ["header", "Header"],
  ["footer", "Footer"],
  ["category-pages", "Category Pages"],
  ["blog-pages", "Blog Pages"],
  ["search-results", "Search Results"],
  ["announcement-bar", "Announcement Bar (site-wide)"],
  ["sticky-footer", "Sticky Footer (site-wide)"],
  ["sticky-sidebar", "Sticky Sidebar (site-wide)"],
  ["floating", "Floating (site-wide)"],
  ["popup", "Popup (site-wide)"],
];

export const DEVICES = ["desktop", "mobile", "tablet"];

export const emptyAd = () => ({
  name: "", type: "image-banner", placements: [], enabled: true, status: "active",
  priority: 0, frequency: 0, image_url: "", link_url: "", html: "", script: "",
  adsense_client: "", adsense_slot: "", adsense_format: "auto",
  video_url: "", video_type: "youtube", autoplay: false, muted: true, loop: false, skip_after: 0,
  cta_text: "", new_tab: true, devices: [], countries: [], categories: [], tools: [],
  start_date: null, end_date: null,
});
